<template>
    <el-dialog :title="dialogTitle" :visible.sync="managerAddDialog" width="520px" :before-close="handleDialogClose" :close-on-click-modal="false" class="custom-form-dialog">
        <el-form ref="formData" :rules="formRules" :model="formData" label-position="top">
            <el-form-item label="管理员类型" prop="type" class="label-bold">
                <el-radio-group v-model="formData.type">
                    <el-radio :label="1">人事主管理员</el-radio>
                    <el-radio :label="2">人事子管理员</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="选择管理员" prop="uid">
                <el-select placeholder="请选择人员，可输入人员姓名搜索" v-model="formData.uid" :remote-method="getUserList" filterable remote reserve-keyword>
                    <el-option v-for="(userItem, userIndex) in userList" :key="userIndex" :value="userItem.id" :label="userItem.name"></el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click.stop="handleDialogClose">取消</el-button>
            <el-button type="primary" @click.stop="handleDialogConfirm">确定</el-button>
        </span>
    </el-dialog>
</template>
<script>
export default {
    props: {
        managerAddDialog: {
            type: Boolean,
            default: false
        },
        haveManager: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            dialogTitle: "添加管理员",
            dialogVisible: false,
            formData: {
                type: "",
                uid: ""
            },
            formRules: {
                uid: [
                    {required: true, message: "请选择管理人员"}
                ]
            },
            userList: []
        }
    },
    methods: {
        handleDialogClose() {
            this.$emit("update:managerAddDialog", false)
        },
        handleDialogConfirm() {

        },
        getUserList(name) {

        }
    }
}
</script>
